export default defineAppConfig({
  name: 'UOB Theatre',
  supportEmail: '&#115;upp&#111;rt&#64;uob&#116;h&#101;atre&#46;com',
  ui: {
    colors: {
      primary: 'sta-gray',
      secondary: 'white',
      success: 'sta-green',
      warning: 'sta-orange',
      error: 'sta-rouge'
    }
  }
});
